import { csrfFetch } from "./csrf.js";
import { gcoreServerUrl } from '../config';

// IF-GNOTICE-001, 공지사항 등록
export const create = async (params) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gnotices`, {
    method: "POST",
    body: JSON.stringify(params),
  });
  const data = await response.json();
  return data.gnotice;
};

// IF-GNOTICE-002, 공지사항 수정
export const modify = async (id, params) => {
  const updatedParams = {
    ...params,
    id: id
  };

  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gnotices/id/${id}`, {
    method: "PUT",
    body: JSON.stringify(updatedParams),
  });
  const data = await response.json();
  return data;
};

// IF-GNOTICE-003, 공지사항 삭제
export const remove = async (id) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gnotices/id/${id}`, {
    method: "DELETE",
  });

  return response;
};

// IF-GNOTICE-004, 공지사항 목록 조회
export const selectAll = async (params) => {
  // URL에 쿼리 파라미터 추가
  const searchParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach(key => {
      searchParams.append(key, params[key]);
    });
  }

  const queryString = searchParams.toString();
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gnotices?${queryString}`);

  const data = await response.json();
  return data.gnotices;
}

// IF-GNOTICE-005, 공지사항 상세 조회
export const select = async (id) => {
  const response = await csrfFetch(null, `${gcoreServerUrl}/api/gnotices/${id}`);
  const data = await response.json();
  return data.gnotice;
}

const initialState = {
};

function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      return state;
  }
}

export default reducer;
